<template lang='pug'>
  .top-nav.centered
    .links
      router-link.link-btn(to='/solutions') Solutions
      router-link.link-btn(to='/free-apps') Free Apps
      router-link.link-btn(to='/about') About Us
</template>

<script>
  export default {

  }
</script>

<style scoped lang="stylus">
  .top-nav
    position fixed
    width 100%
    box-sizing border-box
    box-shadow var(--box-shadow)
    border-top 2px solid rgba(0 0 0 .16)
    text-shadow var(--text-shadow-rev)
    z-index 2
    font-size 1.25em
    color var(--color-text)
    height var(--height-nav)
    background linear-gradient(
      90deg,
      rgba(85 90 100 1),
      rgba(85 80 80 1)
    )
    bottom 0
    left 0

  .links
    padding 8px 32px
    display flex
    width 100%
    max-width 480px
    justify-content center
    box-sizing border-box
    font-family ColaborateLight
    display flex
    justify-content space-between
    a
      padding 8px 16px
      &:hover
        outline 1px solid
      &.active
        color var(--orange)
        filter drop-shadow( 0 0 16px )

    @media (max-width: 480px)
      padding 12px 16px
      font-size .8em
      a
        padding 8px 16px
    @media (max-width: 320px)
      padding 12px 4px
      font-size .75em
</style>
